/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CountUserInsightsParams,
  GetUserInsightsParams,
  UserInsightDto,
  UserInsightRequest
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns user insight by id</br></br>Authorities: **Any authenticated role**
 */
export const getUserInsightById = (
    userId: string,
    id: number,
    insightId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserInsightDto>(
      {url: `/api/${userId}/users/${id}/insights/${insightId}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserInsightByIdQueryKey = (userId: string,
    id: number,
    insightId: number,) => {
    return [
    `/api/${userId}/users/${id}/insights/${insightId}`
    ] as const;
    }


export const getGetUserInsightByIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserInsightById>>, TError = ErrorType<unknown>>(userId: string,
    id: number,
    insightId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsightById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInsightByIdQueryKey(userId,id,insightId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInsightById>>> = ({ signal }) => getUserInsightById(userId,id,insightId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && id && insightId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInsightById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserInsightByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInsightById>>>
export type GetUserInsightByIdQueryError = ErrorType<unknown>


export function useGetUserInsightById<TData = Awaited<ReturnType<typeof getUserInsightById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    insightId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsightById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInsightById>>,
          TError,
          Awaited<ReturnType<typeof getUserInsightById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInsightById<TData = Awaited<ReturnType<typeof getUserInsightById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    insightId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsightById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInsightById>>,
          TError,
          Awaited<ReturnType<typeof getUserInsightById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInsightById<TData = Awaited<ReturnType<typeof getUserInsightById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    insightId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsightById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserInsightById<TData = Awaited<ReturnType<typeof getUserInsightById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    insightId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsightById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserInsightByIdQueryOptions(userId,id,insightId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Updates the user insight relation</br></br>Authorities: **Any authenticated role**
 */
export const updateUserInsight = (
    userId: string,
    id: number,
    insightId: number,
    userInsightRequest: BodyType<UserInsightRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserInsightDto>(
      {url: `/api/${userId}/users/${id}/insights/${insightId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userInsightRequest, signal
    },
      options);
    }



export const getUpdateUserInsightMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserInsight>>, TError,{userId: string;id: number;insightId: number;data: BodyType<UserInsightRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserInsight>>, TError,{userId: string;id: number;insightId: number;data: BodyType<UserInsightRequest>}, TContext> => {

const mutationKey = ['updateUserInsight'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserInsight>>, {userId: string;id: number;insightId: number;data: BodyType<UserInsightRequest>}> = (props) => {
          const {userId,id,insightId,data} = props ?? {};

          return  updateUserInsight(userId,id,insightId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserInsightMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserInsight>>>
    export type UpdateUserInsightMutationBody = BodyType<UserInsightRequest>
    export type UpdateUserInsightMutationError = ErrorType<unknown>

    export const useUpdateUserInsight = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserInsight>>, TError,{userId: string;id: number;insightId: number;data: BodyType<UserInsightRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserInsight>>,
        TError,
        {userId: string;id: number;insightId: number;data: BodyType<UserInsightRequest>},
        TContext
      > => {
      return useMutation(getUpdateUserInsightMutationOptions(options), queryClient);
    }
    /**
 * Returns user insights</br></br>Authorities: **Any authenticated role**
 */
export const getUserInsights = (
    userId: string,
    id: number,
    params?: GetUserInsightsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserInsightDto[]>(
      {url: `/api/${userId}/users/${id}/insights`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserInsightsQueryKey = (userId: string,
    id: number,
    params?: GetUserInsightsParams,) => {
    return [
    `/api/${userId}/users/${id}/insights`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserInsightsQueryOptions = <TData = Awaited<ReturnType<typeof getUserInsights>>, TError = ErrorType<unknown>>(userId: string,
    id: number,
    params?: GetUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsights>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInsightsQueryKey(userId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInsights>>> = ({ signal }) => getUserInsights(userId,id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInsights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInsights>>>
export type GetUserInsightsQueryError = ErrorType<unknown>


export function useGetUserInsights<TData = Awaited<ReturnType<typeof getUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params: undefined |  GetUserInsightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInsights>>,
          TError,
          Awaited<ReturnType<typeof getUserInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInsights<TData = Awaited<ReturnType<typeof getUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params?: GetUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInsights>>,
          TError,
          Awaited<ReturnType<typeof getUserInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInsights<TData = Awaited<ReturnType<typeof getUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params?: GetUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsights>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserInsights<TData = Awaited<ReturnType<typeof getUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params?: GetUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInsights>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserInsightsQueryOptions(userId,id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Returns number of insights</br></br>Authorities: **Any authenticated role**
 */
export const countUserInsights = (
    userId: string,
    id: number,
    params?: CountUserInsightsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<number>(
      {url: `/api/${userId}/users/${id}/insights/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountUserInsightsQueryKey = (userId: string,
    id: number,
    params?: CountUserInsightsParams,) => {
    return [
    `/api/${userId}/users/${id}/insights/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountUserInsightsQueryOptions = <TData = Awaited<ReturnType<typeof countUserInsights>>, TError = ErrorType<unknown>>(userId: string,
    id: number,
    params?: CountUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserInsights>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountUserInsightsQueryKey(userId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countUserInsights>>> = ({ signal }) => countUserInsights(userId,id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countUserInsights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountUserInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof countUserInsights>>>
export type CountUserInsightsQueryError = ErrorType<unknown>


export function useCountUserInsights<TData = Awaited<ReturnType<typeof countUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params: undefined |  CountUserInsightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserInsights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUserInsights>>,
          TError,
          Awaited<ReturnType<typeof countUserInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUserInsights<TData = Awaited<ReturnType<typeof countUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params?: CountUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserInsights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUserInsights>>,
          TError,
          Awaited<ReturnType<typeof countUserInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUserInsights<TData = Awaited<ReturnType<typeof countUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params?: CountUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserInsights>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCountUserInsights<TData = Awaited<ReturnType<typeof countUserInsights>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number,
    params?: CountUserInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserInsights>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountUserInsightsQueryOptions(userId,id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






